import type { SyncState } from '@annoteer/sync-layer';

export interface ConnectionStatusProps {
  state: SyncState;
}

/**
 * Visual connection state indicator.
 * Shows a colored dot with label: green pulsing (connected), amber (connecting), red (disconnected).
 */
export function ConnectionStatus({ state }: ConnectionStatusProps) {
  return (
    <span className={`connection-status connection-status--${state}`}>
      <span className="connection-status__dot" />
      <span className="connection-status__label">{state}</span>
    </span>
  );
}
